export * from './locations.factory'
